export function getTimezoneOffset() {
  return new Date(Date.now()).getTimezoneOffset();
}
